import { render } from "./LangChooser.vue?vue&type=template&id=16a8c30e&scoped=true&ts=true"
import script from "./LangChooser.vue?vue&type=script&lang=ts"
export * from "./LangChooser.vue?vue&type=script&lang=ts"

import "./LangChooser.vue?vue&type=style&index=0&id=16a8c30e&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a8c30e"]])

export default __exports__